export const subheadingStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  mb: ['24px', '24px', '0'],
  mt: ['16px', '16px', '0'],
  pb: ['0', '0', '24px'],
};

export const trialTitleStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
  mb: '16px',
};

export const trialButtonStyles = {
  borderRadius: '10px',
  fontSize: '17px',
  height: '40px',
  mt: '32px',
  padding: '7px 16px',
  sx: { _disabled: { opacity: 1 } },
  textShadow: '0 1px 1px rgba(0, 0, 0, 0.08)',
};

export const contentBoxMobileProps = {
  borderRadius: '0',
  boxShadow: 'none',
  position: 'relative',
  top: '0',
  transform: 'none',
  width: '100%',
};

export const titleStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
  paddingBottom: ['0', '0', '16px'],
  pt: '0',
};
